import Controller from "@ember/controller"
import { action, set } from "@ember/object"
import { inject as service } from "@ember/service"
import registerComponent from "cc-frontend/mixins/register-component"
import { isEqual } from "lodash-es"

export default class ApplicationController extends Controller.extend(registerComponent) {
  token = null
  queryParams = ["promotionCode", "coupon", "openedModals"]
  promotionCode = null
  coupon = null
  openedModals = []
  headElement = document?.head

  @service appState
  @service("ember-store") store
  @service socket
  @service windowscroll
  @service headData

  componentId = "main"

  init() {
    super.init(...arguments)
    this.defaultState = {
      top: 0,
      route: "",
      routeModels: "",
      routeParams: {},
    }
  }

  @action updateOpenedModals(openedModals) {
    if (isEqual(this.openedModals, openedModals) !== true) {
      set(this, "openedModals", openedModals)
    }
  }

  @action setViewPort() {
    if (typeof document !== "undefined" && document.documentElement) {
      document.documentElement.style.setProperty("--vh", `${window.innerHeight}px`)
    }
  }
}
